export default "__VITE_ASSET__CzJ0NZvL__"